import { render, staticRenderFns } from "./PerfilCargo.vue?vue&type=template&id=f61a31a2&scoped=true"
import script from "./PerfilCargo.vue?vue&type=script&lang=js"
export * from "./PerfilCargo.vue?vue&type=script&lang=js"
import style0 from "./PerfilCargo.vue?vue&type=style&index=0&id=f61a31a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61a31a2",
  null
  
)

export default component.exports